import {
  Configuration,
  ProsecutionsApi,
  BlogPostsApi,
  BlogCategoriesApi,
  AuthApi,
  UsersApi,
  SecIndividualsApi,
  SecPositionsApi,
  ProsecutionRolesApi,
  AnalyticsApi,
} from "./definitions";
import { getApiUrl } from "./utils";

// Create a function to get the configuration with auth token
export const getApiConfiguration = (token?: string): Configuration => {
  return new Configuration({
    basePath: getApiUrl(),
    accessToken: token ? `Bearer ${token}` : undefined,
    credentials: "include",
  });
};

// Create API client factory functions
export const createProsecutionsApi = (token?: string) =>
  new ProsecutionsApi(getApiConfiguration(token));

export const createBlogPostsApi = (token?: string) =>
  new BlogPostsApi(getApiConfiguration(token));

export const createBlogCategoriesApi = (token?: string) =>
  new BlogCategoriesApi(getApiConfiguration(token));

export const createAuthApi = (token?: string) =>
  new AuthApi(getApiConfiguration(token));

export const createUsersApi = (token?: string) =>
  new UsersApi(getApiConfiguration(token));

export const createSecIndividualsApi = (token?: string) =>
  new SecIndividualsApi(getApiConfiguration(token));

export const createSecPositionsApi = (token?: string) =>
  new SecPositionsApi(getApiConfiguration(token));

export const createProsecutionRolesApi = (token?: string) =>
  new ProsecutionRolesApi(getApiConfiguration(token));

export const createAnalyticsApi = (token?: string) =>
  new AnalyticsApi(getApiConfiguration(token));

// Default API instances (without auth) - these will now get the correct URL at runtime
export const prosecutionsApi = createProsecutionsApi();
export const blogPostsApi = createBlogPostsApi();
export const blogCategoriesApi = createBlogCategoriesApi();
export const authApi = createAuthApi();
export const usersApi = createUsersApi();
export const secIndividualsApi = createSecIndividualsApi();
export const secPositionsApi = createSecPositionsApi();
export const prosecutionRolesApi = createProsecutionRolesApi();
export const analyticsApi = createAnalyticsApi();
